var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-field',[_c('q-input',{attrs:{"type":"text","disable":_vm.disable,"float-label":_vm.label},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }